import { css } from 'styled-components';

export const materialComplianceRangeWarning = css`
  .material-compliance-range-warning {
    color: ${({ theme }) =>
      theme?.validateMode ? theme.validateMode({ light: '#bb9a1c', dark: '#e0c14a' }) : '#bb9a1c'};
    margin-left: 6px;
    text-transform: none;
  }
`;

export default css`
  .container .spinner {
    margin-top: unset !important;
  }

  .material-compliance-not-found {
    text-align: center;
  }

  ${materialComplianceRangeWarning}

  .row {
    @media (min-width: 951px) {
      display: flex;
      width: 100%;

      & > * {
        &:not(:first-child) {
          margin-left: 10px;
        }

        flex: 1;
      }
    }

    .sensorUnable {
      color: #ff0000;
    }
  }

  .reject-button {
    gap: 38vw;
  }
`;
